module.exports = __webpack_public_path__ + "static/media/Justus.f26d7f94.png";